// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusBadge_status-badge__qHtbp {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}
.StatusBadge_status-badge__qHtbp svg {
  font-size: 18px;
}
@media (max-width: 768px) {
  .StatusBadge_status-badge__qHtbp {
    font-size: 12px;
    padding: 3px 8px;
    gap: 4px;
  }
  .StatusBadge_status-badge__qHtbp svg {
    font-size: 16px;
  }
}

.StatusBadge_status-badge--confirmed__Z7pRn {
  background-color: #e8f5e9;
  color: #1976d2;
}

.StatusBadge_status-badge--cancelled__7vtXb {
  background-color: #ffebee;
  color: #d32f2f;
}

.StatusBadge_status-badge--pending__Euu\\+c {
  background-color: #fffde7;
  color: #f57c00;
}

.StatusBadge_status-badge--processing__RAd6R {
  background-color: #fffde7;
  color: #f57c00;
}

.StatusBadge_status-badge--waiting-payment__tNG5c {
  background-color: #fffde7;
  color: #f57c00;
}

.StatusBadge_status-badge--completed__hfdoD {
  background-color: #e3f2fd;
  color: #388e3c;
}

.StatusBadge_status-badge--publish__9mlkt {
  background-color: #e8f5e9;
  color: #388e3c;
}

.StatusBadge_status-badge--draft__am4LT {
  background-color: #fffde7;
  color: #f57c00;
}

.StatusBadge_status-badge--private__CcxWK {
  background-color: rgba(214, 166, 64, 0.1);
  color: #D6A640;
}

.StatusBadge_status-badge--trash__81ijS {
  background-color: #ffebee;
  color: #d32f2f;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/StatusBadge/StatusBadge.module.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AACJ;AACI;EACI,eAAA;AACR;AAEI;EAdJ;IAeQ,eAAA;IACA,gBAAA;IACA,QAAA;EACN;EACM;IACI,eAAA;EACV;AACF;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ;;AAIA;EACI,yBAAA;EACA,cAAA;AADJ;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yCAAA;EACA,cAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,cAAA;AAAJ","sourcesContent":[".status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    border-radius: 16px;\n    font-size: 14px;\n    font-weight: 500;\n    margin: 0;\n\n    svg {\n        font-size: 18px;\n    }\n\n    @media (max-width: 768px) {\n        font-size: 12px;\n        padding: 3px 8px;\n        gap: 4px;\n\n        svg {\n            font-size: 16px;\n        }\n    }\n}\n\n.status-badge--confirmed {\n    background-color: #e8f5e9;\n    color: #1976d2;\n}\n\n.status-badge--cancelled {\n    background-color: #ffebee;\n    color: #d32f2f;\n}\n\n.status-badge--pending {\n    background-color: #fffde7;\n    color: #f57c00;\n}\n\n.status-badge--processing {\n    background-color: #fffde7;\n    color: #f57c00;\n}\n\n.status-badge--waiting-payment {\n    background-color: #fffde7;\n    color: #f57c00;\n}\n\n\n.status-badge--completed {\n    background-color: #e3f2fd;\n    color: #388e3c;\n}\n.status-badge--publish {\n    background-color: #e8f5e9;\n    color: #388e3c;\n}\n\n.status-badge--draft {\n    background-color: #fffde7;\n    color: #f57c00;\n}\n\n.status-badge--private {\n    background-color: rgba(214, 166, 64, 0.10);\n    color: #D6A640;\n}\n\n.status-badge--trash {\n    background-color: #ffebee;\n    color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status-badge": `StatusBadge_status-badge__qHtbp`,
	"status-badge--confirmed": `StatusBadge_status-badge--confirmed__Z7pRn`,
	"status-badge--cancelled": `StatusBadge_status-badge--cancelled__7vtXb`,
	"status-badge--pending": `StatusBadge_status-badge--pending__Euu+c`,
	"status-badge--processing": `StatusBadge_status-badge--processing__RAd6R`,
	"status-badge--waiting-payment": `StatusBadge_status-badge--waiting-payment__tNG5c`,
	"status-badge--completed": `StatusBadge_status-badge--completed__hfdoD`,
	"status-badge--publish": `StatusBadge_status-badge--publish__9mlkt`,
	"status-badge--draft": `StatusBadge_status-badge--draft__am4LT`,
	"status-badge--private": `StatusBadge_status-badge--private__CcxWK`,
	"status-badge--trash": `StatusBadge_status-badge--trash__81ijS`
};
export default ___CSS_LOADER_EXPORT___;
